import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { encryptStorage } from 'src/app/auth/utils/storage';
import { UserType } from 'src/app/shared/enum/investor-type.enum';

@Injectable({ providedIn: 'root' })
export class PerfilDpgeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): Promise<boolean> {
    const tipo = encryptStorage.getItem('@tipoUsuario', false);

    if (this.hasProfile(tipo)) {
      return Promise.resolve(true);
    }

    return Swal.fire({
      title: 'Atenção',
      icon: 'warning',
      html: `Você não está associado a nenhum perfil DPGE.<br>Deseja realizar o vínculo agora?`,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      allowOutsideClick: false,
    }).then((res) => {
      this.router.navigate([res.isConfirmed ? '/complemento-cadastro' : '/spg']);
      return false;
    });
  }

  private hasProfile(tipo: string): boolean {
    return !!tipo && tipo !== UserType.Undefined;
  }
}
